import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DialogComponent} from './dialog/dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {DialogController} from './dialogController';
import {ButtonModule} from '../../core/component/button/button.module';
import {IonicModule} from '@ionic/angular';
import {DialogWrapperComponent} from './dialog-wrapper/dialog-wrapper.component';
import {MatButtonModule} from "@angular/material/button";
import {
    PermissionRestrictedContainerModule
} from "../permission/api/component/permission-restricted-container/permission-restricted-container.module";

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        ButtonModule,
        IonicModule,
        MatButtonModule,
        PermissionRestrictedContainerModule,
    ],
    providers: [
        DialogController
    ],
    declarations: [DialogComponent, DialogWrapperComponent],
    exports: [
        DialogComponent, DialogWrapperComponent,
    ]
})
export class DialogModule {}
